import angular from 'angular';
import * as R from 'ramda';

export default function EditAssetDialogController(
  $q,
  $rootScope,
  $scope,
  $timeout,

  confirmDialog,
  ssDialogService,
  alerts,
  loaderService,
  riskDataService,
  assetDataService,
  editAssetDialog,
  editRiskDialog,
  assetSharedModelService,
  riskSharedModelService,
  addTypePresetsDialog,
  praDataService
) {
  const vm = this;


  vm.originalAssetTypeId = vm.asset.customerAssetTypeId;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleAssetTypeChange = _handleAssetTypeChange;
  vm.handleEditAssetSubmit = _handleEditAssetSubmit;
  vm.handleAddTypePresetsClick = _handleAddTypePresetsClick;
  vm.handleAddRiskClick = _handleAddRiskClick;
  vm.handleFilterChange = _handleFilterChange;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _initData();
    _filterDataUses();
    $scope.$on('refreshAssetRisks', (event, opt) => {
      if (opt.asset.customerAssetId === vm.newAsset.customerAssetId) {
        loaderService.showViewLoader = true;
        vm.newAsset.presetsNamePrefix = opt.asset.presetsNamePrefix;
        _getAssignedRisks().then(() => {
          loaderService.showViewLoader = false;
        });
      }
    });
  }

  function _initData() {
    vm.firstLoad = true;
    vm.newAsset = angular.copy(vm.asset);
    if (vm.newAsset.customerAssetId === 0) {
      vm.newAsset.isITAsset = true;
      if (vm.preselectedAssetTypeId && vm.preselectedAssetTypeId > 0) {
        vm.newAsset.customerAssetTypeId = vm.preselectedAssetTypeId;
        vm.newAsset.customerAssetType = vm.assetTypes.find(
          assetType => assetType.customerAssetTypeId === vm.preselectedAssetTypeId
        );
        _setAssetTypeDefaults();
      }
    }
    if (vm.newAsset.customerAssetTypeId) {
      vm.selectedAssetTypeId = vm.newAsset.customerAssetTypeId;
    }
    if (vm.newAsset.assetDataTypeId && !vm.newAsset.assetDataType) {
      vm.newAsset.assetDataType = vm.assetDataTypes.find(
        assetDataType => assetDataType.assetDataTypeId === vm.newAsset.assetDataTypeId
      );
    }
    if (vm.newAsset.assetCriticalityId && !vm.newAsset.assetCriticality) {
      vm.newAsset.assetCriticality = vm.assetCriticalities.find(
        assetCriticality => assetCriticality.assetCriticalityId === vm.newAsset.assetCriticalityId
      );
    }
    if (vm.newAsset.assetDataUseId && !vm.newAsset.assetDataUse) {
      vm.newAsset.assetDataUse = vm.assetDataUses.find(
        assetDataUse => assetDataUse.assetDataUseId === vm.newAsset.assetDataTypeId
      );
    }
  }

  function _saveAsset() {
    const isNew = vm.newAsset.customerAssetId <= 0;
    if (!isNew && angular.equals(vm.asset, vm.newAsset)) {
      return Promise.resolve(vm.asset);
    }
    vm.newAsset.assetDataTypeId = vm.newAsset.assetDataType.assetDataTypeId;
    vm.newAsset.assetCriticalityId = vm.newAsset.assetCriticality.assetCriticalityId;
    vm.newAsset.assetDataUseId = vm.newAsset.assetDataUse.assetDataUseId;

    return assetDataService.saveAsset(vm.newAsset).then((response) => {
      if (!response.data) {
        alerts.error('Error occurred while saving the asset.');
      } else {
        alerts.success('The asset has been saved successfully.');
        if (vm.process) {
          if (!vm.process.newIds) {
            vm.process.newIds = [];
          }
          vm.process.newIds.push(response.data.customerAssetId);
        }
        vm.newAsset.customerAssetId = response.data.customerAssetId;
        vm.asset = angular.copy(vm.newAsset);
        // $rootScope.$broadcast('refreshAssets');
        if (isNew === true) {
          if (!vm.process) {
            $rootScope.$broadcast('refreshAssets', { assetType: vm.newAsset.customerAssetType });
          }
          return _saveAssetToProcess();
        }
      }
    });
  }

  function _getAssignedRisks() {
    return assetDataService.getAsset(vm.newAsset.customerAssetId).then((getAssetResponse) => {
      if (!getAssetResponse.data) {
        alerts.error('Error occurred while get the asset.');
      } else {
        const _newAsset = getAssetResponse.data;
        vm.newAsset.customerAssetCustomerRisks = assetSharedModelService.addSeverityDescriptionsToRisks(
          _newAsset.customerRisks
        );
        const customerRiskIds = [];
        R.forEach(
          (customerRisk) => {
            customerRiskIds.push(customerRisk.customerRiskId);
          },
          _newAsset.customerRisks
        );
        vm.newAsset.customerRisks = [];
        R.forEach(
          (customerRiskId) => {
            riskDataService.getRisk(customerRiskId).then((getRiskResponse) => {
              if (!getRiskResponse.data) {
                alerts.error('Error occurred while get the risk.');
              } else {
                vm.newAsset.customerRisks.push(getRiskResponse.data);
              }
              loaderService.showViewLoader = false;
            });
          },
          customerRiskIds
        );
        vm.asset = angular.copy(vm.newAsset);
      }
    });
  }

  function _showEditAssetDialog($event) {
    const asset = { customerAssetId: 0 };
    ssDialogService.dialogs.assetAdmin.editAssetDialog = ssDialogService.alert(
      editAssetDialog.getOptions($event, {
        asset,
        assetCriticalities: assetSharedModelService.AssetCriticalities,
        assetDataTypes: assetSharedModelService.AssetDataTypes,
        assetDataUses: assetSharedModelService.AssetDataUses,
        assetTypes: assetSharedModelService.AssetTypes,
        updateCallBack: vm.updateCallBack,
        process: vm.process,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.assetAdmin.editAssetDialog);
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.assetAdmin.editAssetDialog);
  }

  function _filterDataUses() {
    const isITAsset = vm.newAsset.isITAsset;
    const assetType = isITAsset ? 1 : 2;
    vm.filteredAssetDataUses = R.filter(
      R.propEq('AssetType', assetType),
      vm.assetDataUses
    );
    if (vm.newAsset.assetDataUse) {
      const doesStoreNPI = vm.newAsset.assetDataUse.assetDataUseId === 2
      || vm.newAsset.assetDataUse.assetDataUseId === 4;
      if (isITAsset) {
        vm.newAsset.assetDataUseId = doesStoreNPI ? 2 : 1;
      } else {
        vm.newAsset.assetDataUseId = doesStoreNPI ? 4 : 3;
      }
      vm.newAsset.assetDataUse = vm.assetDataUses.find(
        assetDataUse => assetDataUse.assetDataUseId === vm.newAsset.assetDataUseId
      );
    }
  }

  function _saveAssetToProcess() {
    // const dfdRefresh = $q.defer();
    if (vm.process) {
      const assetIds = [];

      if (vm.process.allAssignedAssets && vm.process.allAssignedAssets.length > 0) {
        R.forEach((asset) => {
          assetIds.push(asset.customerAssetId);
        }, vm.process.allAssignedAssets);
      }

      if (vm.process.newIds && vm.process.newIds.length > 0) {
        R.forEach((id) => {
          assetIds.push(id);
        }, vm.process.newIds);
      }

      // assetIds.push(vm.newAsset.customerAssetId);
      return praDataService.assignAssetsToProcess(vm.process.assessmentProcessId, assetIds)
        .then((response) => {
          if (!response.data) {
            alerts.error('Error occurred while saving the asset for process.');
          } else {
            alerts.success('The assets for process has been saved successfully.');
          }
          loaderService.showViewLoader = false;
        });
    }
    return Promise.resolve();
  }

  function _setAssetTypeDefaults() {
    if (vm.newAsset.customerAssetType) {
      vm.newAsset.customerAssetTypeId = vm.newAsset.customerAssetType.customerAssetTypeId;
      vm.newAsset.isITAsset = vm.newAsset.customerAssetType.isITAsset;
      vm.newAsset.assetDataType = assetSharedModelService.AssetDataTypes.find(
        assetDataType => assetDataType.assetDataTypeId === vm.newAsset.customerAssetType.assetDataTypeId
      );
      vm.newAsset.assetCriticality = assetSharedModelService.AssetCriticalities.find(
        assetCriticality => assetCriticality.assetCriticalityId === vm.newAsset.customerAssetType.assetCriticalityId
      );
      vm.newAsset.assetDataUse = assetSharedModelService.AssetDataUses.find(
        assetDataUse => assetDataUse.assetDataUseId === vm.newAsset.customerAssetType.assetDataUseId
      );
    }
  }

  // //////// HANDLERS //////////

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.assetAdmin.editAssetDialog);
  }

  function _handleAssetTypeChange() {
    if (vm.newAsset.customerAssetId > 0 && vm.firstLoad === true) {
      vm.firstLoad = false;
      return;
    }
    _setAssetTypeDefaults();
  }

  function _handleAddTypePresetsClick($event) {
    vm.isAddRisk = true;
    $scope.editAssetForm.$submitted = true;
    if ($scope.editAssetForm.$valid) {
      vm.isAddRisk = false;
      $scope.editAssetForm.$submitted = false;
      loaderService.showViewLoader = true;
      _saveAsset().then(() => {
        ssDialogService.dialogs.assetAdmin.addTypePresetsDialog = ssDialogService.alert(
          addTypePresetsDialog.getOptions($event, {
            asset: vm.newAsset,
          })
        );
        ssDialogService.show(ssDialogService.dialogs.assetAdmin.addTypePresetsDialog);
        loaderService.showViewLoader = false;
      });
    }
    return false;
  }

  function _handleAddRiskClick($event) {
    vm.isAddRisk = true;
    $scope.editAssetForm.$submitted = true;
    if ($scope.editAssetForm.$valid) {
      vm.isAddRisk = false;
      $scope.editAssetForm.$submitted = false;
      loaderService.showViewLoader = true;
      _saveAsset().then(() => {
        const risk = { customerRiskId: 0 };
        $q.all([
          // riskDataService.getRiskTypes(),
          // assetDataService.getAssets(),
          riskDataService.getRiskById(risk.customerRiskId),
          riskDataService.getRiskTypeDefaults()
        ]).then((response) => {
          risk.riskOnsetId = response[1].data.riskOnset.riskOnsetId;
          risk.riskForewarningId = response[1].data.riskForewarning.riskForewarningId;
          risk.riskDurationId = response[1].data.riskDuration.riskDurationId;
          risk.riskDataConfidentialityId = response[1].data.riskDataConfidentiality.riskDataConfidentialityId;
          risk.riskDataIntegrityId = response[1].data.riskDataIntegrity.riskDataIntegrityId;
          risk.riskDataAvailabilityId = response[1].data.riskDataAvailability.riskDataAvailabilityId;
          risk.riskDirectionId = response[1].data.riskDirection.riskDirectionId;
          risk.riskTrendingId = response[1].data.riskTrending.riskTrendingId;
          risk.riskAssessmentFrequencyId = response[1].data.riskAssessmentFrequency.riskAssessmentFrequencyId;
          risk.riskProbabilityId = response[1].data.riskProbability.riskProbabilityId;
          risk.riskClassificationId = response[1].data.riskClassification.riskClassificationId;
          ssDialogService.dialogs.riskAdmin.editRiskDialog = ssDialogService.alert(
            editRiskDialog.getOptions($event, {
              risk,
              riskTypes: response[0].data.CustomerRiskTypes,
              preselectedAssetId: vm.newAsset.customerAssetId,
              assets: response[0].data.CustomerAssetData,
              asset: vm.newAsset,
              riskOnsets: riskSharedModelService.RiskOnsets,
              riskForewarnings: riskSharedModelService.RiskForewarnings,
              riskDurations: riskSharedModelService.RiskDurations,
              riskDataConfidentialities: riskSharedModelService.RiskDataConfidentialities,
              riskDataIntegrities: riskSharedModelService.RiskDataIntegrities,
              riskDataAvailabilities: riskSharedModelService.RiskDataAvailabilities,
              riskDirections: riskSharedModelService.RiskDirections,
              riskTrendings: riskSharedModelService.RiskTrendings,
              riskAssessmentFrequencies: riskSharedModelService.RiskAssessmentFrequencies,
              riskProbabilities: riskSharedModelService.RiskProbabilities,
              riskClassifications: riskSharedModelService.RiskClassifications,
            })
          );
          ssDialogService.show(ssDialogService.dialogs.riskAdmin.editRiskDialog);
          loaderService.showViewLoader = false;
        });
      });
    }
  }
  
  function _handleEditAssetSubmit($event) {
    if ((vm.originalAssetTypeId !== undefined) && (vm.originalAssetTypeId !== vm.newAsset.customerAssetTypeId)){
      if ((vm.newAsset.presetsNamePrefix === '') || (vm.newAsset.presetsNamePrefix === null) || (vm.newAsset.presetsNamePrefix === undefined)) {
        alerts.error('A prefix must be assigned to the Asset for it to be changed to a new Asset Type.');    
      } else {
        ssDialogService.dialogs.assetAdmin.confirmChangeAssetTypeDialog = ssDialogService.alert(
          confirmDialog.getOptions($event, {
            dialogTitle: 'Change Asset Type?',
            warningMessage: `Changing the Asset Type moves this Asset Instance, impacting your Information Security Risk Assessment. Risks and Controls will be updated to align 
            with the default settings associated with the selected Asset Type.`, 
            message: `Do you want to proceed with this move?`, 
            handleYesClick: _performEditAssetSubmit,
            handleNoClick: _closeConfirmChangeAssetTypeDialog,
          }),
        );

        ssDialogService.show(ssDialogService.dialogs.assetAdmin.confirmChangeAssetTypeDialog);
      }
    } else {
      _performEditAssetSubmit($event);
    }
  }

  function _performEditAssetSubmit($event) {
    if ($scope.editAssetForm.$valid) {
      loaderService.showViewLoader = true;
      _saveAsset().then(() => {
        
        if (vm.originalAssetTypeId !== vm.newAsset.customerAssetTypeId) {
          const newAssetType = {
            customerAssetTypeId: vm.newAsset.customerAssetTypeId
          };
          $rootScope.$broadcast('refreshAssets', { assetType: newAssetType });
        }

        _closeConfirmChangeAssetTypeDialog().then(() => {
          _closeDialog().then(() => {
            loaderService.showViewLoader = false;
            
            if (vm.updateCallBack) {
              vm.updateCallBack();
            }

            if (vm.saveType === 'saveAndAddAnother') {
              $timeout(() => {
                _showEditAssetDialog($event);
              }, 0);
            }
          });
        });
      });
    }
  }

  function _closeConfirmChangeAssetTypeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.assetAdmin.confirmChangeAssetTypeDialog);
  }

  function _handleFilterChange() {
    _filterDataUses();
    vm.newAsset.customerAssetType = undefined;
  }
}

EditAssetDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  '$timeout',

  'confirmDialog',
  'ssDialogService',
  'alerts',
  'loaderService',
  'riskDataService',
  'assetDataService',
  'editAssetDialog',
  'editRiskDialog',
  'assetSharedModelService',
  'riskSharedModelService',
  'addTypePresetsDialog',
  'praDataService',
];
